// src/pages/productos/EliminarProducto.js
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

function EliminarProducto(props) {
	const { producto, cancelar, mostrar, eliminar } = props

	const handleClose = () => {
		cancelar()
	}

	const handleEliminar = () => {
		eliminar(producto?.id)
	}

	if (!producto) return null

	return (
		<Modal show={mostrar} onHide={handleClose} backdrop="static" centered>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar Producto</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					<i className="fa fa-exclamation-triangle me-2"></i>
					Está a punto de eliminar el producto <strong>{producto.nombre}</strong>. Esta acción no se puede deshacer.
				</Alert>

				{producto.multimedia && producto.multimedia.length > 0 && (
					<div className="text-center mb-3">
						<img
							src={`${process.env.REACT_APP_API_URL}/${producto.multimedia[0].url}`}
							alt={producto.nombre}
							style={{ maxHeight: '150px', maxWidth: '100%' }}
							className="img-thumbnail"
						/>
					</div>
				)}

				<p className="mb-0">¿Está seguro que desea eliminar este producto?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-secondary" onClick={handleClose}>
					Cancelar
				</Button>
				<Button variant="danger" onClick={handleEliminar}>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EliminarProducto